import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  shifts: [],
  shift: {},
}

export const mutations = {
  SET_SHIFTS(state, shifts) {
    state.shifts = shifts
  },
  SET_SHIFT(state, shift) {
    state.shift = shift
  },
  ADD_SHIFT(state, shift) {
    state.shifts.push(shift)
  },
  EDIT_SHIFT(state, shift) {
    const index = state.shifts.findIndex(
      (el) => el.shift_uuid === shift.shift_uuid
    )
    if (index !== -1) {
      state.shifts.splice(index, 1, shift)
    }
  },
  DELETE_SHIFT(state, shiftUUID) {
    const index = state.shifts.findIndex((el) => el.shift_uuid === shiftUUID)
    if (index !== -1) state.shifts.splice(index, 1)
  },
}

export const actions = {
  fetchShifts({ commit }, payload) {
    return ApiService.fetchShifts(payload)
      .then((res) => {
        const shifts = res.data.data
        commit('SET_SHIFTS', shifts)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchShift({ commit, getters, state }, id) {
    if (state.shift.shift_id === id) {
      return state.shift
    }

    const shift = getters.getShiftById(id)

    if (shift) {
      commit('SET_SHIFT', shift)
      return shift
    } else {
      return ApiService.fetchShift(id)
        .then((res) => {
          const shift = res.data
          commit('SET_SHIFT', shift)
          return shift
        })
        .catch((error) => {
          throw error
        })
    }
  },
  addShift({ commit }, payload) {
    return ApiService.addShift(payload)
      .then((res) => {
        const shift = res.data
        commit('ADD_SHIFT', shift)
      })
      .catch((error) => {
        throw error
      })
  },
  editShift({ commit }, payload) {
    return ApiService.editShift(payload)
      .then((res) => {
        const shift = res.data
        commit('EDIT_SHIFT', shift)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteShift({ commit }, payload) {
    return ApiService.deleteShift(payload)
      .then(() => {
        commit('DELETE_SHIFT', payload.shiftUUID)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {
  getShiftById: (state) => (id) => {
    return state.shifts.find((el) => el.shift_id === id)
  },
}
